// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#f33535","subMenuActiveText":"#f33535","menuBg":"#384259","menuHover":"#537791","subMenuBg":"#455d7a","subMenuHover":"#537791","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 225